import React, { useEffect, useState } from "react";
import { ShieldAlert, RefreshCw } from "lucide-react";

interface DevToolsWarningProps {
  isVisible: boolean;
  onRefresh: () => void;
}

const DevToolsWarning: React.FC<DevToolsWarningProps> = ({
  isVisible,
  onRefresh,
}) => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => setFadeIn(true), 100);
      return () => clearTimeout(timer);
    } else {
      setFadeIn(false);
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(26, 26, 26, 0.95)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontFamily: 'Arial, sans-serif',
      opacity: fadeIn ? 100 : 0,
      transition: 'opacity 0.5s ease-in-out',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: '2rem',
        borderRadius: '8px',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center',
        border: '1px solid rgba(255, 0, 0, 0.2)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
      }}>
        <ShieldAlert size={48} style={{ color: '#ff3333', marginBottom: '1rem' }} />
        
        <h4 style={{ 
          fontSize: '1.5rem', 
          marginBottom: '0.5rem',
          color: 'white'
        }}>
          Developer Tools Detected
        </h4>
        
        <div style={{
          backgroundColor: 'rgba(255, 51, 51, 0.1)',
          border: '1px solid rgba(255, 51, 51, 0.3)',
          borderRadius: '4px',
          padding: '0.5rem',
          marginBottom: '1.5rem'
        }}>
          <span style={{ color: '#ff3333', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
            <ShieldAlert size={16} />
            Security Alert
          </span>
        </div>

        <p style={{ 
          color: '#cccccc',
          marginBottom: '1.5rem',
          fontSize: '0.9rem'
        }}>
          For security reasons, this website cannot be accessed while developer tools are open.
        </p>

        <div style={{
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          padding: '1rem',
          borderRadius: '4px',
          marginBottom: '1.5rem'
        }}>
          <p style={{ 
            color: 'white',
            marginBottom: '1rem',
            textAlign: 'left',
            fontSize: '0.9rem'
          }}>Please follow these steps:</p>
          
          <ol style={{ 
            textAlign: 'left',
            paddingLeft: '1.5rem',
            marginBottom: '0',
            color: '#cccccc',
            fontSize: '0.9rem'
          }}>
            <li style={{ marginBottom: '0.5rem' }}>
              Close the Inspect Element panel (usually by pressing F12 or right-click menu)
            </li>
            <li>
              Refresh the page to continue browsing
            </li>
          </ol>
        </div>

        <button 
          className="btn"
          style={{
            backgroundColor: 'rgba(255, 51, 51, 0.1)',
            border: '1px solid rgba(255, 51, 51, 0.3)',
            color: '#ff3333',
            width: '100%',
            padding: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
          }}
          onClick={onRefresh}
        >
          <RefreshCw size={16} />
          Refresh Page
        </button>
      </div>
    </div>
  );
};

export default DevToolsWarning;


